import request from '@/utils/request';


// Recharge
export function rechargeList(params) {
  return request({ url: `/recharge/`, method: 'get', params })
}
export function orderCharge(data) {
  return request({ url: `order/charge/`, method: 'post', data })
}
export function orderResult(data) {
  return request({ url: `orderResult/order_payres/`, method: 'post', data })
}



